import { isArray, isEmpty } from 'mc-ui-utils';
import CustomGlanceEvent from '../analytics/CustomGlanceEvent';
import constants from '../constants';
import { UIElement } from '../enums/UIElement';
import State from '../state';
import PubSub from '../state/pubsub';
import { isWebpeek } from './common';
const listeners = {};
export const resetHighlightBridge = (glanceId) => {
    if (!isEmpty(listeners[glanceId]) && isArray(listeners[glanceId])) {
        listeners[glanceId].forEach((listener) => {
            PubSub.unsubscribe(listener[0], listener[1]);
        });
        listeners.glanceId = [];
    }
};
const checkHasListener = (glanceId, message) => {
    if (!isEmpty(listeners[glanceId])) {
        return listeners[glanceId].some((el) => el[0] === message);
    }
    return false;
};
const addInteractionBridges = (context, currentGlanceId
// eslint-disable-next-line sonarjs/cognitive-complexity
) => {
    const navigateEvent = {
        target: {
            dataset: {
                step: 1,
            },
        },
    };
    const interactionListeners = {};
    if (!checkHasListener(currentGlanceId, "MOVE_NEXT_GLANCE" /* MOVE_NEXT_GLANCE */)) {
        interactionListeners["MOVE_NEXT_GLANCE" /* MOVE_NEXT_GLANCE */] = PubSub.subscribe("MOVE_NEXT_GLANCE" /* MOVE_NEXT_GLANCE */, ({ glanceId }) => {
            const { index, currentGlanceIndex } = context.props;
            if (glanceId === currentGlanceId && currentGlanceIndex === index) {
                context.onNavigate(navigateEvent);
            }
        });
    }
    if (!checkHasListener(currentGlanceId, "MOVE_PREV_GLANCE" /* MOVE_PREV_GLANCE */)) {
        const prevEvent = Object.assign(Object.assign({}, navigateEvent), { target: Object.assign(Object.assign({}, navigateEvent.target), { dataset: { step: -1 } }) });
        interactionListeners["MOVE_PREV_GLANCE" /* MOVE_PREV_GLANCE */] = PubSub.subscribe("MOVE_PREV_GLANCE" /* MOVE_PREV_GLANCE */, ({ glanceId }) => {
            const { index, currentGlanceIndex } = context.props;
            if (glanceId === currentGlanceId && currentGlanceIndex === index) {
                context.onNavigate(prevEvent);
            }
        });
    }
    if (!checkHasListener(currentGlanceId, "HOLD_UI" /* HOLD_UI */)) {
        interactionListeners["HOLD_UI" /* HOLD_UI */] = PubSub.subscribe("HOLD_UI" /* HOLD_UI */, ({ glanceId }) => {
            const { index, currentGlanceIndex } = context.props;
            if (glanceId === currentGlanceId && currentGlanceIndex === index) {
                context.onHoldGlance();
            }
        });
    }
    if (!checkHasListener(currentGlanceId, "UNHOLD_UI" /* UNHOLD_UI */)) {
        interactionListeners["UNHOLD_UI" /* UNHOLD_UI */] = PubSub.subscribe("UNHOLD_UI" /* UNHOLD_UI */, ({ glanceId }) => {
            const { index, currentGlanceIndex } = context.props;
            if (glanceId === currentGlanceId && currentGlanceIndex === index) {
                context.onUnHoldGlance();
            }
        });
    }
    for (const listener in interactionListeners) {
        listeners[currentGlanceId].push([
            listener,
            interactionListeners[listener],
        ]);
    }
};
const hideNativeUiElement = (context, currentGlance) => {
    const subscribtionId = PubSub.subscribe("HIDE_UI_ELEMENT" /* HIDE_UI_ELEMENT */, ({ element, glanceId }) => {
        if (glanceId === currentGlance.glanceId) {
            const hiddenElements = JSON.parse(JSON.stringify(context.state.hiddenElements));
            const currentGlanceId = currentGlance.glanceId;
            if (isEmpty(hiddenElements[currentGlanceId]) ||
                isEmpty(hiddenElements[currentGlanceId][element])) {
                context.elementsTobeHidden.push(element);
                if (context.hideElementsInBatch) {
                    clearTimeout(context.hideElementsInBatch);
                }
                context.hideElementsInBatch = window.setTimeout(() => {
                    if (!isEmpty(context.elementsTobeHidden)) {
                        const pending = {};
                        context.elementsTobeHidden.forEach((element) => {
                            pending[element] = true;
                        });
                        context.elementsTobeHidden = [];
                        const alreadyApplied = hiddenElements[currentGlanceId] || {};
                        context.setState({
                            hiddenElements: Object.assign(Object.assign({}, hiddenElements), { [currentGlanceId]: Object.assign(Object.assign({}, alreadyApplied), pending) }),
                        });
                    }
                }, constants.UI_ELEMENT_TIMER);
            }
        }
    });
    listeners[currentGlance.glanceId].push([
        "HIDE_UI_ELEMENT" /* HIDE_UI_ELEMENT */,
        subscribtionId,
    ]);
    return subscribtionId;
};
const showNativeUiElement = (context, currentGlance) => {
    const subscribtionId = PubSub.subscribe("SHOW_UI_ELEMENT" /* SHOW_UI_ELEMENT */, ({ element, glanceId }) => {
        if (glanceId === currentGlance.glanceId) {
            const hiddenElements = JSON.parse(JSON.stringify(context.state.hiddenElements));
            if (!isEmpty(hiddenElements[glanceId]) &&
                !isEmpty(hiddenElements[glanceId][element])) {
                delete hiddenElements[glanceId][element];
                context.setState({
                    hiddenElements,
                });
            }
        }
    });
    listeners[currentGlance.glanceId].push([
        "SHOW_UI_ELEMENT" /* SHOW_UI_ELEMENT */,
        subscribtionId,
    ]);
    return subscribtionId;
};
export const addHighlightsbridge = (context) => {
    const { highlightIndex } = context.state;
    const { bubble: { glances }, } = context.props;
    const currentGlance = glances[highlightIndex];
    if (!isEmpty(currentGlance) && isWebpeek(currentGlance)) {
        if (isEmpty(listeners[currentGlance.glanceId])) {
            listeners[currentGlance.glanceId] = [];
        }
        addInteractionBridges(context, currentGlance.glanceId);
        hideNativeUiElement(context, currentGlance);
        showNativeUiElement(context, currentGlance);
    }
};
export const setCommonBridge = () => {
    window.Gondolin.sendCustomAnalyticsEvent = (glanceId, eventType, extras) => {
        const impressionId = State.impressionMap[glanceId];
        const analyticsEvent = new CustomGlanceEvent(glanceId, impressionId, eventType, extras);
        analyticsEvent.fireEvent();
    };
    window.GlanceAndroidInterface.getNativeUiElements = () => {
        const elements = Object.values(UIElement);
        return JSON.stringify(elements);
    };
    window.GlanceAndroidInterface.isHighlights = () => true;
    window.GlanceAndroidInterface.getBubbleTrayMode = () => "ALWAYS_OFF" /* ALWAYS_OFF */;
    window.GlanceAndroidInterface.isSessionMuted = () => State.isMuted;
};
//# sourceMappingURL=bridgehelper.js.map